
<welcome-page *ngIf="showWelcomePage">
  <button type="button" class="btn btn-primary btn-lg px-4 gap-3" (click)="startSurvey()">{{'welcome.btn'| translate}}</button>
</welcome-page>

<div *ngIf="!showWelcomePage">
  <view-item [questions]='questions' [qa]='qa' [map]='resultMap' (surveyDone)="saveResults()" (updateMap)="updateMap()"></view-item>
</div>

<result-page *ngIf="showResults" [qa]='qa' [map]='resultMap'></result-page>